



























































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { detail as taskDetail,useStatisticList,useBatchCheck } from '@/api/task/common';
import { detail as judgeDetail } from '@/api/task/judge';
import { DOMAIN, JIDU_DOMAIN } from '@/global/constants';
import * as qiniu from 'qiniu-js';

@Component
export default class CheckUser extends Vue {
  private dataList: object[] = [];
  private task: object = {};
  private examineUserSelection = [];
  private searchParams: object = {
    mid: '',
    check_uid: '',
    team_group_id: '',
    count_status:'',
  };
  private columnsSchema: object[] = [
    {
      type: 'selection',
      width: 60,
      align: 'center',
    },
    {
      title: '标注小队ID',
      key: 'team_group_id',
      align: 'center',
    },
    {
      title: '标注人ID',
      key: 'uid',
      align: 'center',
    },
    {
      title: '标注人',
      key: 'nick_name',
      align: 'center',
    },
    {
      title: '标注数量',
      key: 'join_count',
      align: 'center',
    },
    {
      title:'Benchmark',
      slot:'benchmark',
      align:'center'
    },
    {
      title: '审核数量',
      key: 'complete_count',
      align: 'center',
    },
    {
      title: '审核进度',
      key: 'progress',
      align: 'center',
    },
    {
      title: '审核成功率',
      key: 'success_rate',
      align: 'center',
    },
    {
      width: 260,
      title: '操作',
      slot: 'operate',
      align: 'center',
    },
  ];
  @Watch('$route')
  private routechange(to: any, from: any) {
    if (to.name == 'examineUser') {
      // this.getList();
      this.handleReset()
      this.getTask(); // 重新加载数据
    }
  }
  private created() {
    this.getTask();
  }
  private activated(){
    this.getTask();
  }

  private async getTask() {
    this.task = this.$store.state.task;
    if (!(this.task && (this.task as any).id)) {
      const page = this.$route.params.page;
      const params = { id: this.$route.params.id };
      let resp: any;
      if (page == 'judge') {
        resp = await judgeDetail(params);
      } else {
        resp = await taskDetail(params);
      }
      this.$nextTick(() => {
        this.task = resp.result;
        this.$store.commit('setTask', resp.dta);
        this.getList();
      });
    } else {
      this.getList();
    }
  }

  private async getList() {
    const task: any = this.task;
    let params: any = Object.assign({},this.searchParams);
    params.mid = task.id;
    if(this.$route.params.pkg_id && this.$route.params.pkg_id !='0'){
      params.pkg_id =this.$route.params.pkg_id
    }
    try {
      const data = (await useStatisticList(params)) as any;
      console.log(data)
      this.$nextTick(() => {
        if(data){
          this.dataList = data;
          let list=[];
          if(this.searchParams['count_status'] == '1'){
            data.forEach((item)=>{
              if(item.complete_count != 0 || item.join_count !=0){
                list.push(item)
              }
            })
            this.dataList = list;
          }
        }else{
          this.dataList = [];
        }
      });
    } catch (error) {
      this.dataList = [];
      console.log(error);
    }
  }
  // 审核
  private handlecheck(row) {
    const task: any = this.task;
    let params: any = Object.assign({});
    params.id = task.id;
    params.puid=row.uid;
    if(this.$route.params.page){
      params.page=this.$route.params.page
    }else{
      params.page='crowd'
    }
    if(this.$route.params.pkg_id){
      params.pkg_id =this.$route.params.pkg_id
    }
    let routeUrl =this.$router.resolve({
        name: 'examineDetail',
        params: params,
      });
    window.open(routeUrl.href, '_blank');
  }
    // 查看正在标注的题
  private handleCurrent(row){
    const task: any = this.task;
    let from = task.from;
    let url = `${DOMAIN}/tools/${from}.html?type=52&id=${row.businessModuleId}&mlid=${row.currentMlid}&version=2&wuid=${row.uid}`
    //JiDu 兼容jiduNlpPage
    if(from === 'jiduNlpPage'){
      url = `${JIDU_DOMAIN}/nlp?type=52&id=${row.businessModuleId}&mlid=${row.currentMlid}&version=2&wuid=${row.uid}`
    }
    window.open(url);
  }
  // 搜索
  private handleSearch() {
    this.getList();
  }

  // 重置
  private handleReset() {
    this.searchParams = {
      lid: '',
      puid: '',
      pteamid: '',
      count_status:'',
    };
    this.getList();
  }

  public selectChange(selection) {
    this.examineUserSelection = selection;
  }

  public async showBatch(type){
    const select = this.examineUserSelection.map(item => item.id);
    let uids='';
    this.examineUserSelection.forEach((item)=>{
      uids=uids+item.uid+','
    })

    const task: any = this.task;
    let params: any = Object.assign({});
    params.mid = task.id;
    params.uids=uids
    if(this.$route.params.pkg_id && this.$route.params.pkg_id !='0'){
      params.pkg_id =this.$route.params.pkg_id
    }
    params.operate_type=type

    const res: any = await useBatchCheck(params);
    if (res.code === '200') {
      this.$Message.success('操作成功');
    } else {
      this.$Notice.warning({ desc: res.message });
    }
    this.getList();
  }
}
